import React, { FC } from 'react'
import { LocaleCodes } from '../../../constants/localization.constants'
import { PDFWrapper } from './style'

//* components
import Button from '../../global/button'
import SEOTags from '../../global/seoTags'
import Typography from '../../global/typography'
import Layout from '../../layouts/layout'

type Props = {
  pageContext: any
  path: string
}

const PDFPage: FC<Props> = ({ pageContext, path }) => {
  if (!pageContext.pdfData) return null
  const { slug, seoMetadata, pdfDocument } = pageContext.pdfData
  const defaultLocale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const pdfUrl = pdfDocument?.file?.url || '/'

  return (
    <Layout.Template lang={defaultLocale} hideNormalLayout={true} slug={slug || '/'}>
      <PDFWrapper data-cy="PDFPage">
        <SEOTags
          seoMetadata={seoMetadata}
          slug={slug || '/'}
          locale={defaultLocale}
          path={path}
          siteSection="Resource Demo"
        />

        <div className="PDFPage__Mobile">
          <Typography type="header1">
            This browser does not support mobile PDF rendering. Instead, you can download the PDF
            file by clicking the button below.
          </Typography>

          <Button
            icon={true}
            href={pdfUrl}
            text="Download now"
            type={'primary'}
            size={'medium'}
            theme={'dark'}
          />
        </div>

        <object
          width="100%"
          height="100%"
          id="PDFWrapper-Object"
          data={pdfUrl}
          type="application/pdf"
          style={{ height: '100vh', minHeight: '100vh' }}>
          <iframe
            width="100%"
            height="100%"
            style={{ height: '100%', minHeight: '100vh', width: '100%' }}
            id="PDFWrapper-Object"
            src={`${pdfUrl}`}>
            <p>
              This browser does not support PDF rendering. Instead, you can
              <a href={pdfUrl}>click here to download the PDF file.</a>
            </p>
          </iframe>
        </object>
      </PDFWrapper>
    </Layout.Template>
  )
}

export default PDFPage
